import { createContext, useContext, useEffect, useState } from "react";
import { dict } from "./dict";

const LangContext = createContext({ lang: "fr", t: dict.fr, setLang: () => {} });

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("ah-lang") || "fr");
  useEffect(() => {
    localStorage.setItem("ah-lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);
  return <LangContext.Provider value={{ lang, setLang, t: dict[lang] }}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);
